/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { environmentsDeleteBySlug } from "../funcs/environmentsDeleteBySlug.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteEnvironmentRequest,
  DeleteEnvironmentSecurity,
} from "../models/operations/deleteenvironment.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteEnvironmentMutationVariables = {
  request: DeleteEnvironmentRequest;
  security?: DeleteEnvironmentSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteEnvironmentMutationData = void;

export type DeleteEnvironmentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteEnvironment environments
 *
 * @remarks
 * Delete an environment
 */
export function useDeleteEnvironmentMutation(
  options?: MutationHookOptions<
    DeleteEnvironmentMutationData,
    DeleteEnvironmentMutationError,
    DeleteEnvironmentMutationVariables
  >,
): UseMutationResult<
  DeleteEnvironmentMutationData,
  DeleteEnvironmentMutationError,
  DeleteEnvironmentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteEnvironmentMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteEnvironment(): MutationKey {
  return ["@gram/client", "environments", "deleteBySlug"];
}

export function buildDeleteEnvironmentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteEnvironmentMutationVariables,
  ) => Promise<DeleteEnvironmentMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteEnvironment(),
    mutationFn: function deleteEnvironmentMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteEnvironmentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(environmentsDeleteBySlug(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
